import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgProgressService } from '@shared/services/ng-progress.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-profile',
  imports: [CommonModule, CardModule, AngularSvgIconModule],
  templateUrl: './profile.component.html',
})
export class ProfileComponent {
  private readonly _ngProgressService = inject(NgProgressService);

  ngOnInit(): void {
    this._ngProgressService.startLoader();
  }

  ngAfterViewInit(): void {
    this._ngProgressService.completeLoader();
  }
}
